<div class="locator-container layout-spacing">
    <app-territory-map
        variant="locator"
        [showControls]="false"
        [borderRadius]="'10px'"
        [popupTemplate]="popupTpl() ?? null" />

    @if (locatorService.deleteModalVisible()) {
        <app-confirmation-modal
            [isVisible]="locatorService.deleteModalVisible()"
            type="delete"
            title="Delete Territory"
            [message]="
                'Are you sure you want to delete ' +
                (locatorService.territoryToDelete() ?? 'this territory') +
                '? This action cannot be undone.'
            "
            confirmText="Delete"
            cancelText="Cancel"
            (confirm)="locatorService.closeDeleteModal()"
            (cancel)="locatorService.closeDeleteModal()"
            (modalClose)="locatorService.closeDeleteModal()" />
    }
</div>

<!-- Territory popup template — passed to the map via [popupTemplate] input.
     $implicit context = territory.popupData set in locator.component.ts
     
     TEMPORARY
     -->
<ng-template #territoryPopupTpl let-data>
    <div class="t-popup">
        <div class="t-popup__grid">
            <div class="t-popup__field">
                <span class="t-popup__label">Assigned Dealer</span>
                <span class="t-popup__value">{{ data.assignedDealer }}</span>
            </div>
            <div class="t-popup__field">
                <span class="t-popup__label">Longitude</span>
                <span class="t-popup__value">{{ data.longitude }}</span>
            </div>
            <div class="t-popup__field">
                <span class="t-popup__label">Territory Name</span>
                <span class="t-popup__value">{{ data.territoryName }}</span>
            </div>
            <div class="t-popup__field">
                <span class="t-popup__label">Latitude</span>
                <span class="t-popup__value">{{ data.latitude }}</span>
            </div>
            <div class="t-popup__field">
                <span class="t-popup__label">Total Area</span>
                <span class="t-popup__value">{{ data.totalArea }} km²</span>
            </div>
            <div class="t-popup__field">
                <span class="t-popup__label">Created</span>
                <span class="t-popup__value">{{ data.createdDate | date: 'M/d/yyyy' }}</span>
            </div>
        </div>
    </div>
</ng-template>
